module.exports = __webpack_public_path__ + "img/leamh_icon.9267ed5.png";